import ReactGA from 'react-ga4';

// Inicializar Google Analytics
export const initGA = (measurementId) => {
  if (measurementId) {
    ReactGA.initialize(measurementId);
    console.log('Google Analytics inicializado');
  } else {
    console.warn('Google Analytics Measurement ID no configurado');
  }
};

// Registrar una vista de página
export const logPageView = (path, title) => {
  ReactGA.send({ 
    hitType: 'pageview', 
    page: path,
    title: title 
  });
  console.log(`GA: Pageview registrado - ${path}`);
};

// Registrar un evento personalizado
export const logEvent = (category, action, label = null, value = null) => {
  const eventParams = {
    category,
    action,
  };
  
  if (label) eventParams.label = label;
  if (value !== null) eventParams.value = value;
  
  ReactGA.event(eventParams);
  console.log('GA: Evento registrado', eventParams);
};

// Registrar tiempo en página (útil para blog details)
export const logTiming = (category, variable, value, label = null) => {
  const timingParams = {
    category,
    variable,
    value,
  };
  
  if (label) timingParams.label = label;
  
  ReactGA.gtag('event', 'timing_complete', timingParams);
  console.log('GA: Timing registrado', timingParams);
};

export default {
  initGA,
  logPageView,
  logEvent,
  logTiming,
};
